module.exports = __webpack_public_path__ + "static/git-41e177979e9a8009c94d7d37df603602.png";